class DetailsDisclosure extends HTMLElement {
  constructor () {
    super()
    this.mainDetailsToggle = this.querySelector('details')
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this))
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this))
  }

  onFocusOut () {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close()
    })
  }

  onToggle () {
    if (!this.animations) this.animations = this.content.getAnimations()

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play())
    } else {
      this.animations.forEach((animation) => animation.cancel())
    }
  }

  close () {
    this.mainDetailsToggle.removeAttribute('open')
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false)
  }
}

customElements.define('details-disclosure', DetailsDisclosure)

class HeaderMenu extends DetailsDisclosure {
  constructor () {
    super()
    // Check if this header-menu is within the offcanvas header
    const offcanvasHeader = this.closest('.sleepdoctor-header-offcanvas')
    if (offcanvasHeader) {
      this.header = offcanvasHeader
    } else {
      this.header = document.querySelector('.header-wrapper')
    }
  }

  onToggle () {
    if (!this.header) return
    this.header.preventHide = this.mainDetailsToggle.open

    // Only set the CSS variable if this is the offcanvas header
    const isOffcanvasHeader = this.header.classList.contains('sleepdoctor-header-offcanvas')
    if (isOffcanvasHeader && document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return
    if (isOffcanvasHeader) {
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      )
    }
  }
}

customElements.define('header-menu', HeaderMenu)
